import { useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'

import MultiSelectBox from '../../../../../../../../features/components/Form/MultiSelectBox'

import { getLoadOptionsHandlerCursorPagination } from '../../../../../../../../features/helpers/componentsHelpers'

import { getGoogleAdManagerConstantsService } from '../../../../../../../../modules/services/rights'

import { selfAccountSelector } from '../../../../../../../../modules/selectors/selfAccounts'
import { GAM_NETWORK_CODE } from '../../../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'
import { DEVICE_CATEGORY, gamConstantsTypes } from '../../../fields'

const DeviceCategorySelect = ({ formik }) => {
  const { values, setFieldValue } = formik

  const selfAccount = useSelector(selfAccountSelector)
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const formatOptions = useCallback(options => {
    return options.map(option => ({
      ...option,
      value: option.id,
      label: option.name
    }))
  }, [])

  const loadOptions = useMemo(() => {
    return getLoadOptionsHandlerCursorPagination({
      getOptionsService: getGoogleAdManagerConstantsService,
      params: {
        network_code: gamNetworkCode,
        constant_type: gamConstantsTypes.Device_Category
      },
      formatOptions: formatOptions
    })
  }, [formatOptions, gamNetworkCode])

  return (
    <MultiSelectBox
      loadOptions={loadOptions}
      value={values[DEVICE_CATEGORY]}
      name={DEVICE_CATEGORY}
      setFieldValue={setFieldValue}
      placeholder="Device Category"
      portaled={true}
    />
  )
}

export default DeviceCategorySelect
